import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerXBusinessPostingGroup } from "../../../models/General/BusinessPostingGroup.models";

interface CustomerXBusPostingGroupState {
  customerXBusPostingGroups: ICustomerXBusinessPostingGroup[];
  customerXBusPostingGroupToEdit: ICustomerXBusinessPostingGroup | null;
}

const initialState: CustomerXBusPostingGroupState = {
  customerXBusPostingGroups: [],
  customerXBusPostingGroupToEdit: null,
};

const customerXBusPostingGroupSlice = createSlice({
  name: "CustomerXBusPostingGroup",
  initialState,
  reducers: {
    setCustomerXBusPostingGroupList: (
      state,
      action: PayloadAction<ICustomerXBusinessPostingGroup[]>
    ) => {
      state.customerXBusPostingGroups = action.payload;
    },
    concatListCustomerXBusPostingGroup: (
      state: CustomerXBusPostingGroupState,
      action: PayloadAction<ICustomerXBusinessPostingGroup[]>
    ) => {
      state.customerXBusPostingGroups = [
        ...state.customerXBusPostingGroups.concat(action.payload),
      ];
    },
    setCustomerXBusPostingGroupToEdit: (
      state,
      action: PayloadAction<ICustomerXBusinessPostingGroup | null>
    ) => {
      state.customerXBusPostingGroupToEdit = action.payload;
    },
    addCustomerXBusPostingGroup: (
      state,
      action: PayloadAction<ICustomerXBusinessPostingGroup>
    ) => {
      state.customerXBusPostingGroups.push(action.payload);
    },
    updateCustomerXBusPostingGroup: (
      state,
      action: PayloadAction<ICustomerXBusinessPostingGroup>
    ) => {
      let itemIndex = state.customerXBusPostingGroups.findIndex(
        item =>
          item.customerXGenBusPostingGroupId ===
          action.payload.customerXGenBusPostingGroupId
      );
      if (itemIndex !== -1)
        state.customerXBusPostingGroups[itemIndex] = action.payload;
    },
    deleteCustomerXBusPostingGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.customerXBusPostingGroups.filter(
        item => item.customerXGenBusPostingGroupId !== action.payload
      );
      state.customerXBusPostingGroups = newArray;
    },
  },
});

export const {
  setCustomerXBusPostingGroupList,
  concatListCustomerXBusPostingGroup,
  setCustomerXBusPostingGroupToEdit,
  addCustomerXBusPostingGroup,
  updateCustomerXBusPostingGroup,
  deleteCustomerXBusPostingGroup,
} = customerXBusPostingGroupSlice.actions;

export default customerXBusPostingGroupSlice.reducer;
